import React from "react";

/**
 * GOLDORA brand mark — uses the OFFICIAL high-resolution logo extracted from the
 * original PDF. Two assets are used:
 *   - /goldora-icon-trans.png   (icon only, transparent bg)
 *   - /goldora-logo-full-trans.png (full stack: icon + wordmark + divider + tagline)
 *
 * Props:
 *   size: px (icon height / or full stack height when stacked)
 *   withWordmark: boolean (render wordmark inline beside icon)
 *   stacked: boolean (render the full stacked brand — icon + wordmark + divider + tagline)
 *   className: optional
 */
const ICON_SRC = "/goldora-icon-trans.png";
const FULL_SRC = "/goldora-logo-full-trans.png";

export default function Logo({ size = 36, withWordmark = false, stacked = false, className = "" }) {
  if (stacked) {
    return (
      <img
        src={FULL_SRC}
        alt="GOLDORA — Visão global. Você no controle."
        width={Math.round(size * 1.2)}
        height={size}
        style={{ height: size, width: "auto" }}
        className={className}
        draggable="false"
      />
    );
  }

  const iconEl = (
    <img
      src={ICON_SRC}
      alt="GOLDORA"
      width={size}
      height={size}
      style={{ height: size, width: size }}
      className="object-contain"
      draggable="false"
    />
  );

  if (!withWordmark) return <span className={className}>{iconEl}</span>;

  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      {iconEl}
      <span className="font-brand text-lg tracking-[0.16em] brand-metal">GOLDORA</span>
    </span>
  );
}
